module.exports = "<soco-system-message messageType=\"AccessDenied\"></soco-system-message>\n"